import { render, staticRenderFns } from "./productInfomationUpload.vue?vue&type=template&id=c35b05bc&scoped=true&"
import script from "./productInfomationUpload.vue?vue&type=script&lang=js&"
export * from "./productInfomationUpload.vue?vue&type=script&lang=js&"
import style0 from "./productInfomationUpload.vue?vue&type=style&index=0&id=c35b05bc&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35b05bc",
  null
  
)

export default component.exports